let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gpOI7")).then(() => parcelRequire('jdptg'));